import { useSelector } from 'react-redux';
import { selectFeatureFlagData } from 'store/featureFlag/featureFlagSelector';

// BEAST-13036's activity-events flag is deliberately NOT exposed here. Its two readers - the
// tracking saga (which cannot use a hook) and `useActivityFocusTracker` - both take
// `selectIsActivityEventsEnabled` directly, so adding it would put a `useSelector` subscription on
// every component that uses this hook for a value none of them read.

const useFeatureFlag = () => {
    const {
        inventoryEnabled: isInventoryEnabled,
        dynamicFormsEnabled: isDynamicFormsEnabled,
        dynamicFormsEnabledActiveObjectIds: dynamicFormsEnabledActiveObjectIds,
        clientEquipmentEnabled: isClientEquipmentEnabled,
        keycloakIntegrationEnabled: isKeycloakIntegrationEnabled,
        circleCheckEnabled: isCircleCheckEnabled,
    } = useSelector(selectFeatureFlagData);
    return {
        isInventoryEnabled,
        isDynamicFormsEnabled,
        dynamicFormsEnabledActiveObjectIds,
        isClientEquipmentEnabled,
        isKeycloakIntegrationEnabled,
        isCircleCheckEnabled,
    };
};

export default useFeatureFlag;
